<template>
  <div class="qtt-msg-box" v-show="visible">
    <div class="qtt-msg-panel">
      <header>
        <i class="el-icon-close" @click="closePanel('cancel')"></i>
      </header>
      <div class="qtt-msg-content">
        <!-- <slot></slot> -->
        <p v-show="content">{{ content }}</p>
      </div>
      <div class="qtt-message-action">
        <el-button type="primary" @click="closePanel('sure')"
          >确定 {{ shortCut ? '(空格)' : '' }}</el-button
        >
        <el-button @click="closePanel('cancel')"
          >取消 {{ shortCut ? 'Esc' : '' }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<style lang="less">
.qtt-msg-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5000;
  .qtt-msg-panel {
    opacity: 1;
    display: flex;
    position: relative;
    z-index: 5001;
    flex-direction: column;
    border-radius: 4px;
    max-width: 320px;
    padding: 15px 10px;
    background: white;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    header {
      text-align: right;
      i {
        margin-right: 8px;
      }
    }
    .qtt-msg-content {
      flex: 1;
      text-align: center;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .qtt-message-action {
      text-align: center;
      max-height: 30px;
    }
  }
}
</style>
<script>
import Popup from 'element-ui/src/utils/popup'
import Locale from 'element-ui/src/mixins/locale'
export default {
    mixins: [Popup, Locale],

    props: {
        modal: {
            default: true
        },
        lockScroll: {
            default: true
        },
        showClose: {
            type: Boolean,
            default: true
        },
        closeOnClickModal: {
            default: true
        },
        closeOnPressEscape: {
            default: true
        }
    },
    data() {
        return {
            // visible: false,
            title: '',
            content: '',
            shortCut: true,
            action: '',
            showInput: false
        }
    },
    methods: {
        showPanel() {
            this.visible = true
        },
        getSafeClose() {
            const currentId = this.uid
            return () => {
                this.$nextTick(() => {
                    if (currentId === this.uid) this.doClose()
                })
            }
        },
        doClose() {
            if (!this.visible) return
            this.visible = false
            this._closing = true

            this.onClose && this.onClose()

            if (this.lockScroll) {
                setTimeout(() => {
                    if (this.modal && this.bodyOverflow !== 'hidden') {
                        document.body.style.overflow = this.bodyOverflow
                        document.body.style.paddingRight = this.bodyPaddingRight
                    }
                    this.bodyOverflow = null
                    this.bodyPaddingRight = null
                }, 200)
            }
            this.opened = false

            if (!this.transition) {
                this.doAfterClose()
            }
            if (this.action) this.callback(this.action, this)
        },

        closePanel(action) {
            if (!this.visible) return
            this.visible = false
            this._closing = true
            this.action = action
            this.onClose && this.onClose()

            if (this.lockScroll) {
                setTimeout(() => {
                    if (this.modal && this.bodyOverflow !== 'hidden') {
                        document.body.style.overflow = this.bodyOverflow
                        document.body.style.paddingRight = this.bodyPaddingRight
                    }
                    this.bodyOverflow = null
                    this.bodyPaddingRight = null
                }, 200)
            }
            this.opened = false

            if (!this.transition) {
                this.doAfterClose()
            }
            if (this.action) this.callback(this.action, this)
        }
    },
    mounted() {
        let self = this
        document.addEventListener('keyup', function(evt) {
            // debugger;
            if (evt.keyCode === 27) {
                self.action = 'cancel'
                self.onClose && self.onClose()
                self.callback(self.action, self)
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// MessageBoxOwn.vue?6139f5e7